module.exports = __webpack_public_path__ + "img/official_accounts_website_1.baedf5e2.png";